import axiosInstance from './axiosInstance';

const paymentService = {
    createPayment: async (paymentData) => {
        try {
            const response = await axiosInstance.post('/payments', paymentData);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    getAllPayments: async (params) => {
        try {
            const response = await axiosInstance.get('/payments', { params });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    updatePayment: async (id, paymentData) => {
        try {
            const response = await axiosInstance.put(`/payments/${id}`, paymentData);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    getStudentPayments: async (studentId) => {
        try {
            const response = await axiosInstance.get(`/payments/student/${studentId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    markInstallmentPaid: async (installmentId) => {
        try {
            const response = await axiosInstance.put(`/payments/installment/${installmentId}/paid`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
};

export default paymentService;
